import React from 'react'
import './footer.scss'

const Footer = () => {
  return (
    <section className="footer">
      <span>Developed by Zohra Neda 2024 | All rights reserved</span>
    </section>
  )
}

export default Footer
